const $ = window.$


export function fetchReviews(){
  let currentReviews = window.cm.store.getState().reviewPage
  return $.ajax({
    type: "GET",
    url: window.cm.urls['reviews-api'],
    data: {
      page: currentReviews.page,
      category: currentReviews.filters.category,
      rating: currentReviews.filters.rating
    },
    success: function(resp){
      window.cm.store.dispatch({
        'type': 'UPDATE_REVIEWS_SUCCESS',
        'responseData': resp
      })
    },
    error: function(resp){
      window.cm.store.dispatch({
        'type': 'UPDATE_REVIEWS_ERROR',
        'responseData': resp
      })
    }
  })
}
